import { mutatorAction } from 'satcheljs';
import { default as getAccountBySourceId } from '../selectors/getAccountBySourceId';
import {
    accountSourceDataTypeChecker,
    AdditionalAccountInfo,
} from '../store/schema/AccountSourceList';

export default mutatorAction(
    'SET_ARCHIVE_ACCOUNT',
    function (sourceId: string, archiveSources: AdditionalAccountInfo): void {
        if (archiveSources.sources.length > 1) {
            throw new Error('archiveSources can not contain more than one archive account');
        }

        const hostingAccount = getAccountBySourceId(sourceId);
        if (!hostingAccount || !accountSourceDataTypeChecker.isM365UserMailbox(hostingAccount)) {
            throw new Error(
                'We are attempting to set Archive Account Info to a Non-M365UserMailboxAccountSource'
            );
        }

        hostingAccount.archiveSources = archiveSources;
    }
);
